export enum WalletTransactionTypeIdEnum {
  DEPOSIT_ITEMS = 1, // от пополнения скинами
  DOUBLE_GAME_BET = 2,
  SHOP_PURCHASE = 3,
  DOUBLE_GAME_WIN = 4,
  REFERRAL = 5,
  CLASSIC_OR_FAST_PLAYED = 6,
  SHOP_REVOKE = 7,
  WARWICK_RESERVE = 8,
  WARWICK_RELEASE = 9,
  WARWICK_WINNING = 10,
  PAYMENT = 11, // от платежной системы
  DUEL_GAME_BET = 12,
  DUEL_GAME_WIN = 13,
  DUEL_GAME_RETURN = 14,
  BALANCE_PAYMENT = 15,
  FREE_COINS = 16,
  REFERRAL_WELCOME_BONUS = 17,
  SLOTS_GAME_BET = 18,
  SLOTS_GAME_WINNING = 19,
  CRASH_GAME_BET = 20,
  CRASH_GAME_WIN = 21,
  MANUAL_REFUND = 22,
  TRADE_REFUND = 23,
  PROMOCODE = 24,
  KING_BET = 25,
  KING_WIN = 26,
  KING_BONUS = 27,
  UPGRADER_PLAY = 28,
  UPGRADER_SELL = 29,
  CASE_PLAY = 30,
  CASE_SELL = 31,
  DAILY_GIFTS = 32,
  GLOBAL_POT = 33,
  WHEEL_REFILL = 34,
  SKIN_SELL = 35,
  X50_BET = 36,
  X50_WIN = 37,
  VIRTUAL_BET = 38,
  PAYOUT = 39,
  PAYOUT_REVOKE = 40,
  TOWER_GAME_BET = 41,
  TOWER_GAME_WIN = 42,
  WHEEL_SPIN = 43,
  MINI_JACKPOT_WIN = 44,
  DOUBLE_GAME_TRIPLE_WIN = 45,
  HILO_BET = 46,
  HILO_WIN = 47,
  JACKPOT_REWARD = 48,
  BOOST_REWARD = 49,
  MONEY_MOVE_FROM_DAPUBG = 50,
  XP_REWARD = 51,
  CASHBACK_REWARD = 52,
  BACCARAT_PLAY = 53,
  BACCARAT_WIN = 54,
  CROSS_RETURN = 55,
  POGGI_SLOTS_BET = 56,
  POGGI_SLOTS_WIN = 57,
  WHEEL_FREE_BONUS = 58,
  CASES_FREE_BONUS = 59,
  HTTP_API_TAKE = 60,
  LEADERS_RACE_REWARD = 61,
  TAKING_RAFFLE_ITEM = 62,
  UNUSED_MONEY = 63,
  INVENTORY_SELL = 64,
  INVENTORY_BUY = 65,
  P2P_PAYOUT = 67,
  P2P_REFUND = 68,
  P2P_REFILL = 69,
  P2P_BOT_REFILL = 70,
  OFFERWALL_PAYMENT = 71,
  RESET_BALANCE = 72,
  CASE_BATTLE_BET = 80,
  CASE_BATTLE_WIN = 81,
  /** Case battles: accept revenge invite (debit entry) */
  CASE_BATTLE_REVENGE_ACCEPT = 82,
  /** Case battles: revenge refund (timeout / cancel / accept race) */
  CASE_BATTLE_REVENGE_REFUND = 83,
  CASE_REFUND = 90,
  INVENTORY_WITHDRAW_REFUND = 91,
  // RAIN
  RAIN_BET = 100,
  RAIN_REFILL = 101,
  RAIN_REWARD = 102,
  //RAFFLE
  RAFFLE_REFILL = 103,
  RAFFLE_REWARD = 104,
  RAFFLE_REWARD_CREATE = 105,
  RAFFLE_REWARD_DELETE = 106,
  // LEADERS-RACE
  QUEST_PAY = 500,
  QUEST_PAY_REFUND = 501,
  QUEST_REWARD = 503,
  // BONUS
  LUCKY_BONUS = 504,
  BONUS_FROM_BET = 505,
  GET_BONUS = 506,
  // LEADERS-RACE - QUEST_CALENDAR
  QUEST_CALENDAR_REWARD = 507,
  GET_FREE_WALLET = 508,
  EXCHANGE_WALLET = 509,
  DEPOSIT_ITEMS_COMPENSATION_HOLD = 510,
  // SEASONAL QUESTS
  SEASONAL_QUESTS_REWARD = 550,
  // SOLITAIRE
  SOLITAIRE_ENTRY_COST = 600,
  SOLITAIRE_PRIZE = 601,
  SOLITAIRE_REFUND = 602,
  // BET (сервис ставок/спортбук; провайдер-агностично). ВНИМАНИЕ: id должны быть заведены
  // в реестре типов транзакций (bonus_points_log_type / новый wallet) — согласовать перед прод-релизом.
  /** Списание ставки (bet/make). */
  BET_STAKE = 700,
  /** Зачисление выигрыша (bet/win). */
  BET_WIN = 701,
  /** Возврат отменённой ставки (bet/refund). */
  BET_REFUND = 702,
  /** Коррекция баланса при откате расчёта (bet/rollback). */
  BET_ROLLBACK = 703,
  /** Возврат ставки при сбое bet/make (bet/discard). */
  BET_DISCARD_REFUND = 704,
}
